class BlogController {
	static load() {
		$.getJSON(`${this.baseURL}load`, {
			Start: this.currentIndex,
			Length: 4,
			FilterCategory: this.filterId
		}).then(results => {
			if (results instanceof Array) {
				this.currentIndex += results.length;

				if (results.length < 4) {
					$(".load-more").addClass("hide");
				}

				for (let article of results) {
					$(".articles").append($(article));
				}

				this.updateLastArticle();
			}
		});
	}

	static setFilterId(id, url = null) {
		this.filterId = id;

		$(".articles").attr("data-filter-id", id);

		if (id == null) {
			$(".articles article").removeClass("hide");
			$(".category-filter .category").removeClass("selected").first().addClass("selected");
		}
		else {
			$(".category-filter .category").removeClass("selected").filter(`[data-id=${id}]`).addClass("selected");
			$(".articles article").removeClass("hide").filter(`:not([data-categories~=${id}])`).addClass("hide");
		}

		this.updateLastArticle();
		this.updateCarousel();

		if (url != null) {
			history.pushState({
				categoryID: id
			}, document.title, url);
		}
	}

	static updateLastArticle() {
		$(".articles article").removeClass("last").filter(":not(.hide)").last().addClass("last");
	}

	static updateCarousel() {
		let articles = $(".featured-carousel .carousel article:not(.hide)");

		if (articles.length == 0) return;

		let { width } = articles[0].getBoundingClientRect();

		$(".featured-carousel .controls .line").css("width", `${(width / (articles.length * width)) * 100}%`);
	}

	static init() {
		this.filterId = $(".articles").attr("data-filter-id");
		this.baseURL = $(".articles").attr("data-base-url");
		this.currentIndex = 4;

		$(".featured-carousel .carousel").slick({
			infinite: false,
			slidesToShow: 1,
			variableWidth: true,
			dots: false,
			arrows: false
		});

		$(".featured-carousel .controls .prev").on("click", () => {
			$(".featured-carousel .carousel").slick("slickPrev");
		});

		$(".featured-carousel .controls .next").on("click", () => {
			$(".featured-carousel .carousel").slick("slickNext");
		});

		$(".featured-carousel .carousel").on("beforeChange", (_event, _slick, _currentSlide, nextSlide) => {
			$(".featured-carousel .controls .line").css("transform", `translateX(${nextSlide * 100}%)`);
		});

		this.updateCarousel();
		this.updateLastArticle();

		$(document).on("click", ".load-more", () => {
			this.load();
		});

		// $(document).on("click", ".category-filter .category", event => {
		// 	let self = $(event.currentTarget);
		// 	let id = self.attr("data-id");
        //
		// 	if (id == "all") {
		// 		this.setFilterId(null, this.baseURL);
		// 	}
		// 	else {
		// 		this.setFilterId(id, `${this.baseURL}filter/${self.attr("data-category")}`);
		// 	}
		// });

		$(window).on("popstate", event => {
			if (event.originalEvent.state != undefined) {
				this.setFilterId(event.originalEvent.state.categoryID);
			}
		});
	}
}
